export const playerOperationKey = actorId => 'sportya-player-creation:' + actorId
export const readPending = key => {
  try {
    const data = JSON.parse(sessionStorage.getItem(key))
    return /^[a-zA-Z0-9-]{16,128}$/.test(data?.operationId || '') && /^[a-zA-Z0-9-]{16,128}$/.test(data?.correlationId || '')
      ? { operationId: data.operationId, correlationId: data.correlationId } : null
  } catch { return null }
}
export const savePending = (key, request) => {
  try {
    if (request) sessionStorage.setItem(key, JSON.stringify({ operationId: request.operationId, correlationId: request.correlationId }))
    else sessionStorage.removeItem(key)
  } catch { /* The in-memory operation remains available when storage is disabled. */ }
}
export const newPlayerOperationId = () => {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
}
export const invitationLabels = {
  pending: 'The invitation is queued. Sending has not yet been confirmed.', sending: 'The email service is sending the invitation.',
  sent: 'The email server accepted the invitation. This does not confirm delivery to the inbox.',
  failed: 'The invitation could not be sent. You can resend it from the player profile.',
  unconfirmed: 'Invitation sending is not confirmed. Check its status or resend it from the player profile.',
  consumed: 'The player has used the invitation and activated the account.',
}
